import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {FormTypesData, KeyValueData} from '../../../domains/common.domain';
import {LocalStorageService} from '../../../services/local-storage.service';

import {PersonalDataService} from '../personal-data.service';
import {InstallationFlowType} from '../../../constants/app.constants';
import {FormSubsectionsVisibility} from '../../technician-data/technician-data.domain';
import {EnvironmentService} from '../../../services/environment.service';

@Component({
  selector: 'app-responsible-installer',
  styleUrls: ['./responsible-installer.component.scss'],
  templateUrl: './responsible-installer.component.html',
})

export class ResponsibleInstallerComponent implements OnInit {
  @Input() installerData: any;
  @Input() isReadOnly: boolean = false;

  currentInstallationFlow: string;
  formSubSections: FormSubsectionsVisibility;
  infoBubblesData: {
    [key: string]: boolean;
  };
  installationFlowType: KeyValueData;
  installerFG: FormGroup;
  selectedFacilities: FormTypesData[];

  constructor(
    private localStorageService: LocalStorageService,
    private personalDataService: PersonalDataService,
    private environmentService: EnvironmentService,
  ) {
    this.installationFlowType = InstallationFlowType;
    this.currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
  }

  ngOnInit(): void {
    this.selectedFacilities = this.localStorageService.getItem('selected_facilities') || [];
    this.infoBubblesData = this.environmentService.getInfoBubblesData('personalData') || null;
    this.formSubSections = {
      gas: false,
      heating: false,
      power: false,
      water: false,
    };
    this.selectedFacilities.forEach((item) => {
      this.formSubSections[item.key] = true;
    });
    this.prepareForm();
    this.personalDataService.updatePersonalDataForm(this.installerFG, 'responsibleInstaller');
  }

  private prepareForm(): void {
    this.installerFG = new FormGroup({
      // installerCheckbox: new FormControl(this.installerData && this.installerData.installerCheckbox || false),
      power: new FormGroup({
        taxId: new FormControl(this.installerData && this.installerData.power
          && this.installerData.power.taxId || '',
          // this.addValidation(this.formSubSections.power),
        ),
        companyName: new FormControl(this.installerData && this.installerData.power
          && this.installerData.power.companyName || '',
          // this.addValidation(this.formSubSections.power),
        ),
        telephoneNumber: new FormControl(this.installerData && this.installerData.power
          && this.installerData.power.telephoneNumber || '',
          // this.addValidation(this.formSubSections.power),
        ),
      }),
      gas: new FormGroup({
        taxId: new FormControl(this.installerData && this.installerData.gas
          && this.installerData.gas.taxId || '',
          // this.addValidation(this.formSubSections.gas),
        ),
        companyName: new FormControl(this.installerData && this.installerData.gas
          && this.installerData.gas.companyName || '',
          // this.addValidation(this.formSubSections.gas),
        ),
        telephoneNumber: new FormControl(this.installerData && this.installerData.gas
          && this.installerData.gas.telephoneNumber || '',
          // this.addValidation(this.formSubSections.gas),
        ),
      }),
      water: new FormGroup({
        taxId: new FormControl(this.installerData && this.installerData.water
          && this.installerData.water.taxId || '',
          // this.addValidation(this.formSubSections.water),
        ),
        companyName: new FormControl(this.installerData && this.installerData.water
          && this.installerData.water.companyName || '',
          // this.addValidation(this.formSubSections.water),
        ),
        telephoneNumber: new FormControl(this.installerData && this.installerData.water
          && this.installerData.water.telephoneNumber || '',
          // this.addValidation(this.formSubSections.water),
        ),
      }),
      heating: new FormGroup({
        taxId: new FormControl(this.installerData && this.installerData.heating
          && this.installerData.heating.taxId || '',
          // this.addValidation(this.formSubSections.heating),
        ),
        companyName: new FormControl(this.installerData && this.installerData.heating
          && this.installerData.heating.companyName || '',
          // this.addValidation(this.formSubSections.heating),
        ),
        telephoneNumber: new FormControl(this.installerData && this.installerData.heating
          && this.installerData.heating.telephoneNumber || '',
          // this.addValidation(this.formSubSections.heating),
        ),
      }),
    });

    Object.keys(this.formSubSections).forEach(
      (key) => {
        if (!this.formSubSections[key]) {
          this.installerFG.removeControl(key);
        }
      });

    this.installerFG.valueChanges.subscribe(() => {
      this.personalDataService.updatePersonalDataForm(this.installerFG, 'responsibleInstaller');
    });
  }

  // addControlsForWater(event:any):void {
  //   if(event){
  //     this.installerFG.addControl('companyNameForWater', new FormControl(''));
  //     this.installerFG.addControl('telephoneNumberForWater', new FormControl(''))
  //   }else{
  //     this.installerFG.removeControl('companyNameForWater');
  //     this.installerFG.removeControl('telephoneNumberForWater');
  //   }
  // }

  /*private addValidation = (isRequired: boolean): Validators => isRequired ? [Validators.required] : [];*/
}
